import { TCustomField } from 'src/components/company/programs/createProgram';
import * as Yup from 'yup';

const createEventDetailsSchema = ({ fields }: { fields: TCustomField[] }) => {
  const shape: { [key: string]: any } = {
    title: Yup.string().required('Please enter the event name'),
    startDate: Yup.string().required('Please select the start date'),
    endDate: Yup.string()
      .required('Please select the end date'),
    startTime: Yup.string().required('Please select the start time'),
    endTime: Yup.string().required('Please select the end time')
  };

  try {
    fields.forEach((field) => {
      const id: string = field?.id;

      const preSelectedField = id === 'aboutEvent'

      if (preSelectedField) {
        return undefined;
      } else if (field?.type === 'label') {
        const validator = Yup.string().required('Please enter details in this field');
        shape[id] = validator;
      } else {
        const validator = Yup.string().required('Please enter details in this field');
        shape[id] = validator;
        shape[`${id}-label`] = validator;
      }
    });

    return Yup.object().shape(shape);
  } catch {
    return Yup.object().shape(shape);
  }
};

export default createEventDetailsSchema;
